export default __webpack_public_path__ + "static/media/ANISHA ARORA.c124e7e4.jpg";